export class CancelMealReasonMiniEntity {
  id?: number
  title?: string | null
}
